/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailableModel } from '../../models/available-model';

export interface SessionAvailableSystemIdentifierIdProfileIdGet$Params {

/**
 * The system identifier ID
 */
  systemIdentifierId: string;

/**
 * The profile ID
 */
  profileId: string;
}

export function sessionAvailableSystemIdentifierIdProfileIdGet(http: HttpClient, rootUrl: string, params: SessionAvailableSystemIdentifierIdProfileIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<AvailableModel>> {
  const rb = new RequestBuilder(rootUrl, sessionAvailableSystemIdentifierIdProfileIdGet.PATH, 'get');
  if (params) {
    rb.path('systemIdentifierId', params.systemIdentifierId, {});
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<AvailableModel>;
    })
  );
}

sessionAvailableSystemIdentifierIdProfileIdGet.PATH = '/Session/Available/{systemIdentifierId}/{profileId}';
